import React, { Component } from "react";

import {
  CBadge,
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CFormGroup,
  CLabel,
  CInput,
  CTextarea,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CCol
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
// eslint-disable-next-line import/order
import Loading from "../../../../components/Loading";
// eslint-disable-next-line import/order
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
// eslint-disable-next-line import/order
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";
// eslint-disable-next-line import/order

class NotificationCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // detail: false,
      loading: true,
      roles: [],
      studentSelected: [],
      students: [],
      rooms: [],
      schools: [],
      regions: [],
      groups: [],
      selectedRoles: [],
      // selectedDisciplines: [],
      // disciplinesModal: false,
      title: "",
      description: "",
      // docs: [],
      file: null,
      name: null,
      idNotification: null
    };

    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}access/role/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respRole => {
          axios
            .get(`${URL.api}access/region/list`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(
              respRegion => {
                axios
                  .get(`${URL.api}access/group/list`, {
                    headers: {
                      authorization: `Bearer ${this.props.user.token}`
                    }
                  })
                  .then(
                    respGroup => {
                      axios
                        .get(`${URL.api}access/school/list`, {
                          headers: {
                            authorization: `Bearer ${this.props.user.token}`
                          }
                        })
                        .then(
                          respSchool => {
                            let rolesAux = [];
                            let idAux = 9;
                            for (
                              let i = 0;
                              i < this.props.user.user_roles.length;
                              i++
                            ) {
                              if (
                                this.props.user.user_roles[i].role_id < idAux
                              ) {
                                idAux = this.props.user.user_roles[i].role_id;
                              }
                            }
                            respRole.data.data.map(item => {
                              if (item.id > idAux) {
                                rolesAux.push({
                                  value: item.id,
                                  label: item.name,
                                  type: item.type
                                });
                              }
                            });

                            this.setState(
                              {
                                roles: rolesAux,
                                groups: respGroup.data.data.map(item => ({
                                  value: item.id,
                                  label: item.name
                                })),
                                regions: respRegion.data.data.map(item => ({
                                  value: item.id,
                                  label: item.name,
                                  group_id: item.group_id
                                })),
                                schools: respSchool.data.data.map(item => ({
                                  value: item.id,
                                  label: item.name,
                                  region_id: item.region_id
                                }))
                              },
                              () => {
                                if (!id) {
                                  this.setState({ loading: false });
                                } else {
                                  axios
                                    .get(
                                      `${URL.api}communication/notice/singleView/${id}`,
                                      {
                                        headers: {
                                          authorization: `Bearer ${this.props.user.token}`
                                        }
                                      }
                                    )
                                    .then(
                                      resp => {
                                        const InicioString =
                                          // eslint-disable-next-line prefer-template
                                          URL.public + "uploads/activity/";
                                        this.setState(
                                          {
                                            title: resp.data.data.title,
                                            file:
                                              resp.data.data?.uploads[0]
                                                ?.file || null,
                                            name:
                                              resp.data.data.uploads[0]?.file.replace(
                                                InicioString,
                                                ""
                                              ) || null,
                                            description:
                                              resp.data.data.description,
                                            selectedRoles:
                                              resp.data.data.roles.map(
                                                item => ({
                                                  role_id: item.role_id,
                                                  group_id: item.group_id,
                                                  region_id: item.region_id,
                                                  school_id: item.school_id,
                                                  room_id: item.room_id,
                                                  student_id: null,
                                                  role_type:
                                                    respRole.data.data.find(
                                                      role =>
                                                        role.id === item.role_id
                                                    ).type
                                                })
                                              )
                                          },
                                          () => {
                                            this.setState({
                                              edit: true,
                                              loading: false
                                            });
                                          }
                                        );
                                      },
                                      error => {
                                        this.error(error.response.statusText);
                                      }
                                    );
                                }
                              }
                            );
                          },
                          error => {
                            this.error(error.response.statusText);
                          }
                        );
                    },
                    error => {
                      this.error(error.response.statusText);
                    }
                  );
              },
              error => {
                this.error(error.response.statusText);
              }
            );
        },
        error => {
          this.error(error.response.statusText);
        }
      );

    // Atualizar lista de Turma
    axios
      .get(
        `${URL.api}community/room/list?class=true&school[]=${this.props.general.active_roles.school_id}`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(resp => {
        if (resp.data.success) {
          let turmas = [];
          resp.data.data.map(room => {
            let obj = { label: room.name, value: room.id };
            turmas.push(obj);
          });
          this.setState({ rooms: turmas });
        }
      });

    // Atualizar lista de Alunos
    // let obj = {
    //   room: 118
    // };
    // axios
    //   .post(`${URL.api}community/room_user/list`, obj, {
    //     headers: { authorization: `Bearer ${this.props.user.token}` }
    //   })
    //   .then(resp => {
    //     let alunos = [];
    //     resp.data.data.map(aluno => {
    //       if (aluno.role_id === 7)
    //         alunos.push({ label: aluno.user_name, value: aluno.user_id });
    //     });
    //     this.setState({ students: alunos });
    //   });
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  validator(validator) {
    for (let i = 0; i < validator.length; i++) {
      if (!validator[i].value) {
        toastr.error("Erro", `Favor preencher o campo ${validator[i].label}`);
        return false;
      }
    }

    return true;
  }

  enviar() {
    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      room_id: item.room_id
    }));

    let arr = [];
    this.state.selectedRoles.map(item => {
      if (item.student_id != null) arr.push(item.student_id);
    });

    const obj = {
      user_id: this.props.user.user.id,
      title: this.state.title,
      type: "notice",
      description: this.state.description,
      roles: role,
      users: arr,
      uploads: this.state.file ? [this.state.file] : undefined
    };

    axios
      .post(`${URL.api}communication/notice/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          idNotification: resp.data.data
        });
        toastr.success("Sucesso", "O aviso foi criado.");
        this.props.history.push("/notice/me");
      });
  }

  gerarNotificação() {
    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      room_id: item.room_id
    }));

    let arr = [];
    this.state.selectedRoles.map(item => {
      if (item.student_id != null) arr.push(item.student_id);
    });

    const obj = {
      user_id: this.props.user.user.id,
      title: this.state.title,
      type: "notification",
      description: this.state.description,
      roles: role,
      users: arr,
      notices: [this.state.idNotification]
    };

    axios
      .post(`${URL.api}communication/notice/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.props.history.push("/notice/me");
      });
  }

  atualizar() {
    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      room_id: item.room_id,
      student_id: item.student_id
    }));

    const obj = {
      title: this.state.title,
      description: this.state.description,
      roles: role,
      uploads: [this.state.file]
    };

    const { id } = this.props.match.params;

    axios
      .post(`${URL.api}communication/notice/update/${id}`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        toastr.success("Sucesso", "O aviso foi atualizado.");
        this.props.history.push("/notice/me");
      });
  }

  AdicionarAnexo() {}

  onCloseModal(selected = null) {
    if (selected !== null) {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ selectedDisciplines: selected });
    }

    // eslint-disable-next-line react/no-unused-state
    this.setState({ disciplinesModal: false });
  }

  addRole() {
    this.setState(state => {
      const prev = [...state.selectedRoles];
      prev.push({
        role_id: null,
        group_id: this.props.general.active_roles.group_id,
        region_id: this.props.general.active_roles.region_id,
        school_id: this.props.general.active_roles.school_id,
        role_type: null,
        room_id: null,
        student_id: null
      });

      return { selectedRoles: prev };
    });
  }

  removeRole(index) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev.splice(index, 1);

      let { principal } = state;

      if (principal === index) {
        principal = null;
      } else if (principal > index) {
        principal -= 1;
      }

      return { selectedRoles: prev, principal };
    });
  }

  changeRole(index, value, type) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].role_id = value;
      prev[index].role_type = type;

      return { selectedRoles: prev };
    });
  }

  changeGroup(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].group_id = value;
      prev[index].region_id = null;
      prev[index].school_id = null;
      prev[index].room_id = null;
      prev[index].student_id = null;

      return { selectedRoles: prev };
    });
  }

  changeRegion(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].region_id = value;
      prev[index].school_id = null;

      return { selectedRoles: prev };
    });
  }

  changeSchool(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].school_id = value;
      prev[index].room_id = null;
      prev[index].student_id = null;

      axios
        .get(`${URL.api}community/room/list?class=true&school[]=${value}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            let turmas = [];
            resp.data.data.map(room => {
              let obj = { label: room.name, value: room.id };
              turmas.push(obj);
            });
            this.setState({ rooms: turmas });
          }
        });
      return { selectedRoles: prev };
    });
  }

  changeRoom(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].room_id = value;
      prev[index].student_id = null;

      let arr = [...state.studentSelected];
      let objAux = { label: "Nome do estudante", value: null };
      arr[index] = objAux;

      let obj = { room: value };

      // Pego todos os alunos de uma turmaa
      axios
        .post(`${URL.api}community/room_user/list`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          // eslint-disable-next-line react/no-access-state-in-setstate
          if (this.state.students[0]) {
            // se já tiver algum elemento
            // eslint-disable-next-line react/no-access-state-in-setstate
            let alunos = [...this.state.students];
            let atom = [];
            // atom.push({ label: "Todos os Alunos", value: -1 });
            resp.data.data.map(aluno => {
              if (aluno.role_id === 7)
                atom.push({ label: aluno.user_name, value: aluno.user_id });
            });
            alunos[index] = [...atom];
            this.setState({ students: alunos });
          } else {
            // se não tiver algum elemento
            // eslint-disable-next-line react/no-access-state-in-setstate
            let alunos = [...this.state.students];
            let atom = [];
            // atom.push({ label: "Todos os Alunos", value: -1 });
            resp.data.data.map(aluno => {
              if (aluno.role_id === 7)
                atom.push({ label: aluno.user_name, value: aluno.user_id });
            });
            alunos.push(atom);
            this.setState({ students: alunos });
          }
        });
      return { selectedRoles: prev, studentSelected: arr };
    });
  }

  changeStudent(index, value, label) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].student_id = value;

      let arr = [...state.studentSelected];
      arr[index] = { label, value };

      return { selectedRoles: prev, studentSelected: arr };
    });
  }

  limparAnexos() {
    this.setState({ file: null, name: null });
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/notice/me", to: "/notice/me" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Aviso" : "Criar Aviso"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o aviso selecionada"
                    : "Crie um novo aviso"}
                </div>
              </div>
              <CButton
                color="primary"
                onClick={() =>
                  this.state.edit ? this.atualizar() : this.enviar()
                }
              >
                <i className="fa fa-cloud-upload mr-2"></i>Salvar
              </CButton>
            </CCardHeader>
            <CCardBody>
              <CFormGroup>
                <CLabel>Título</CLabel>
                <CInput
                  placeholder="Digite o título  do aviso"
                  value={this.state.title}
                  onChange={e => this.setState({ title: e.target.value })}
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel>Descrição</CLabel>
                <CTextarea
                  placeholder="Digite a descrição  do aviso"
                  rows={4}
                  value={this.state.description}
                  onChange={e => this.setState({ description: e.target.value })}
                />
              </CFormGroup>
              <CFormGroup>
                <CLabel className="d-block">Enviar para</CLabel>

                {this.state.selectedRoles.map((item, index) => (
                  <div
                    className="d-flex w-100 mb-3 align-items-center"
                    key={index}
                  >
                    <CRow style={{ flex: 1 }} className="mr-3">
                      <CCol xs="3">
                        <CFormGroup className="m-0">
                          <CInputGroup className="input-prepend">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Select
                              isSearchable
                              placeholder="Perfil"
                              name="Perfil"
                              options={this.state.roles}
                              classNamePrefix="select"
                              className="flex-1"
                              value={this.state.roles.find(
                                option => option.value === item.role_id
                              )}
                              defaultValue={this.state.roles.find(
                                option => option.value === item.role_id
                              )}
                              onChange={e =>
                                this.changeRole(index, e.value, e.type)
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                      </CCol>
                      <CCol xs="3">
                        {["U", "R", "E", "P", "A", "S"].includes(
                          item.role_type
                        ) && (
                          <CFormGroup className="m-0">
                            <CInputGroup className="input-prepend">
                              <CInputGroupPrepend>
                                <CInputGroupText>
                                  <i className="fa fa-user"></i>
                                </CInputGroupText>
                              </CInputGroupPrepend>
                              <Select
                                isSearchable
                                placeholder="Grupo"
                                name="Grupo"
                                options={this.state.groups}
                                classNamePrefix="select"
                                className="flex-1"
                                value={
                                  this.state.groups.find(
                                    option => option.value === item.group_id
                                  ) || { value: null, label: "Grupo" }
                                }
                                defaultValue={this.state.groups.find(
                                  option => option.value === item.group_id
                                )}
                                onChange={e => this.changeGroup(index, e.value)}
                                isDisabled={
                                  this.props.general.active_roles.group_id !==
                                  null
                                }
                              />
                            </CInputGroup>
                          </CFormGroup>
                        )}
                      </CCol>
                      <CCol xs="3">
                        {["R", "E", "P", "A", "S"].includes(item.role_type) && (
                          <CFormGroup className="m-0">
                            <CInputGroup className="input-prepend">
                              <CInputGroupPrepend>
                                <CInputGroupText>
                                  <i className="fa fa-user"></i>
                                </CInputGroupText>
                              </CInputGroupPrepend>
                              <Select
                                isSearchable
                                placeholder="Região"
                                name="Região"
                                options={this.state.regions.filter(
                                  region => region.group_id === item.group_id
                                )}
                                classNamePrefix="select"
                                className="flex-1"
                                value={
                                  this.state.regions.find(
                                    option => option.value === item.region_id
                                  ) || { value: null, label: "Região" }
                                }
                                defaultValue={this.state.regions.find(
                                  option => option.value === item.region_id
                                )}
                                onChange={e =>
                                  this.changeRegion(index, e.value)
                                }
                                isDisabled={
                                  this.props.general.active_roles.region_id !==
                                  null
                                }
                              />
                            </CInputGroup>
                          </CFormGroup>
                        )}
                      </CCol>
                      <CCol xs="3">
                        {["E", "P", "A", "S"].includes(item.role_type) && (
                          <CFormGroup className="m-0">
                            <CInputGroup className="input-prepend">
                              <CInputGroupPrepend>
                                <CInputGroupText>
                                  <i className="fa fa-user"></i>
                                </CInputGroupText>
                              </CInputGroupPrepend>
                              <Select
                                isSearchable
                                placeholder="Escola"
                                name="Escola"
                                options={this.state.schools.filter(
                                  region => region.region_id === item.region_id
                                )}
                                classNamePrefix="select"
                                className="flex-1"
                                value={
                                  this.state.schools.find(
                                    option => option.value === item.school_id
                                  ) || { value: null, label: "Escola" }
                                }
                                defaultValue={this.state.schools.find(
                                  option => option.value === item.school_id
                                )}
                                onChange={e =>
                                  this.changeSchool(index, e.value)
                                }
                                isDisabled={
                                  this.props.general.active_roles.school_id !==
                                  null
                                }
                              />
                            </CInputGroup>
                          </CFormGroup>
                        )}
                      </CCol>
                      <CCol xs="3" style={{ marginTop: "15px" }}>
                        {this.state.selectedRoles[index].role_type === "A" && (
                          <CFormGroup className="m-0">
                            <CInputGroup className="input-prepend">
                              <CInputGroupPrepend>
                                <CInputGroupText>
                                  <i className="fa fa-user"></i>
                                </CInputGroupText>
                              </CInputGroupPrepend>
                              <Select
                                isSearchable
                                placeholder="Turma"
                                name="Turma"
                                options={this.state.rooms}
                                classNamePrefix="select"
                                className="flex-1"
                                value={
                                  this.state.rooms.find(
                                    option => option.value === item.room_id
                                  ) || { value: null, label: "Turma" }
                                }
                                // defaultValue={this.state.rooms.find(
                                //   option => option.value === item.room_id
                                // )}
                                onChange={e => this.changeRoom(index, e.value)}
                                // isDisabled={
                                //   this.props.general.active_roles.school_id !==
                                //   null
                                // }
                              />
                            </CInputGroup>
                          </CFormGroup>
                        )}
                      </CCol>
                      <CCol xs="3" style={{ marginTop: "15px" }}>
                        {this.state.selectedRoles[index].role_type === "A" && (
                          <CFormGroup className="m-0">
                            <CInputGroup className="input-prepend">
                              <CInputGroupPrepend>
                                <CInputGroupText>
                                  <i className="fa fa-user"></i>
                                </CInputGroupText>
                              </CInputGroupPrepend>
                              <Select
                                isSearchable
                                placeholder="Nome do estudante"
                                name="Estudante"
                                options={this.state.students[index]}
                                classNamePrefix="select"
                                className="flex-1"
                                value={
                                  this.state.studentSelected[index] || {
                                    value: null,
                                    label: "Nome do estudante"
                                  }
                                }
                                defaultValue={this.state.rooms.find(
                                  option => option.value === item.room_id
                                )}
                                onChange={e =>
                                  this.changeStudent(index, e.value, e.label)
                                }
                                // isDisabled={
                                //   this.props.general.active_roles.school_id !==
                                //   null
                                // }
                              />
                            </CInputGroup>
                          </CFormGroup>
                        )}
                      </CCol>
                    </CRow>
                    <CButton
                      variant="outline"
                      color="secondary"
                      className="ml-3 text-dark"
                      onClick={() => this.removeRole(index)}
                    >
                      <i className="fa fa-trash"></i>
                    </CButton>
                  </div>
                ))}
                <CButton
                  variant="outline"
                  color="secondary"
                  className="text-dark"
                  onClick={() => this.addRole()}
                >
                  Adicionar um perfil
                </CButton>
              </CFormGroup>

              <CFormGroup>
                <CLabel className="d-block">Anexo</CLabel>

                {/* <CButton
                  variant="outline"
                  color="secondary"
                  className="text-dark"
                  onClick={() => this.AdicionarAnexo()}
                >
                  Adicionar
                </CButton> */}
                {this.state.file && (
                  <>
                    {" "}
                    <CBadge
                      color="light"
                      className="mfe-2 p-2 cursor btn-light"
                    >
                      <i className="fa fa-file mr-2"></i>
                      {this.state.name}
                    </CBadge>
                    <CButton
                      variant="outline"
                      color="secondary"
                      className="ml-3 text-dark"
                      onClick={() => this.limparAnexos()}
                    >
                      <i className="fa fa-trash"></i>
                    </CButton>
                  </>
                )}
                {this.state.file == null && (
                  <Uploader
                    type="activity"
                    maxFiles={1}
                    allowMultiple
                    labelIdle="Clique aqui ou arraste um arquivo para cá"
                    done={(uploads, names) =>
                      this.setState({
                        file: URL.public + uploads[0],
                        name: names[0]
                      })
                    }
                  />
                )}
              </CFormGroup>
            </CCardBody>
            <ProtectedRoute routeId={this.props.currentRoute} />
          </CCard>
        )}
        {/* {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <CCard>
            <CCardBody>
              <CFormGroup>
                <CLabel className="titulo d-block">Título</CLabel>
                <CLabel>{this.state.title}</CLabel>
              </CFormGroup>
              <CFormGroup>
                <CLabel className="titulo d-block">Descrição</CLabel>
                <CLabel>{this.state.description}</CLabel>
              </CFormGroup>
              <CFormGroup>
                <CLabel className="titulo d-block">Anexo</CLabel>

                <CButton
                  variant="outline"
                  color="secondary"
                  className="text-dark"
                  onClick={() => this.AdicionarAnexo()}
                >
                  Listar anexos
                </CButton>
              </CFormGroup>{" "}
              <div className="x">
                <CButton
                  color="success"
                  className="ciente"
                  onClick={() => this.props.history.push("/notice/detail/{}")}
                >
                  Estou Ciente
                </CButton>
              </div>
            </CCardBody>
          </CCard>
        )} */}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCreate);
